import { route } from "ziggy-js";
import qs from "qs";
import { Ziggy } from "./ziggy";
import "./internet-connection";
import { fileUploader } from "./filepond/manager";
import { FilePondManager } from "./filepond/filepond-manager";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { FilePond } from "./filepond/plugins";
import OTPKit from "./otp-lib";
import intlTelInput from "intl-tel-input";
import venoBox from "venobox";
import "./utils/plateRenderer";
import { reportDaterangeOptions } from "./reports-daterange";

// Pass the Ziggy object to the route function
window.route = (name, params, absolute, config = Ziggy) =>
    route(name, params, absolute, config);
window.fileUploader = fileUploader;
window.FilePondManager = FilePondManager;
window.qs = qs;
window.FilePond = FilePond;
window.OTPKit = OTPKit;

dayjs.extend(utc);
dayjs.extend(timezone);
window.dayjs = dayjs;
window.intlTelInput = intlTelInput;
window.loadUtils = () => import("intl-tel-input/build/js/utils.js");
window.VenoBox = venoBox;
// Same date-range picker (presets, month/year dropdowns, RTL) as admin/analytics.
window.reportDaterangeOptions = reportDaterangeOptions;

// Modal z-index handler for nested modals.
// app.js is bundled by Vite and runs as a deferred module from <head>; jQuery
// is loaded later from plugins.bundle.js in the body, so wait for it.
function bindNestedModalZIndex() {
    const $ = window.jQuery;
    if (!$) return false;
    $(document).on("show.bs.modal", ".modal", function () {
        const zIndex = 1050 + 10 * $(".modal:visible").length;
        $(this).css("z-index", zIndex);
        setTimeout(() => {
            $(".modal-backdrop")
                .not(".modal-stack")
                .css("z-index", zIndex - 1)
                .addClass("modal-stack");
        });
    });
    return true;
}

if (!bindNestedModalZIndex()) {
    window.addEventListener("load", bindNestedModalZIndex);
}
